import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import Header from "../header";
import { Link } from "react-router-dom";
import styles from "../home/index.module.css";
import AuthServices from "../../services/AuthServices";
import { CheckImage, logo, LogoImage } from "../imagepath";
const CareGiver = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="main-wrapper">
      <Header />
      <section>
        <h1
          className="text-center align-content-center p-4"
          style={{ background: "#00112B", color: "white" }}
          title="Caregiver Emergency Training | Child Care Safety Certification | AngelWatch"
        >
          Emergency Training and Certification for Child Caregivers | AngelWatch
        </h1>
        <p
          className="m-auto p-4"
          style={{ maxWidth: "1000px" }}
          title="Prepare caregivers to protect lives with AngelWatch Emergency Certification. Full training for active shooter response, fires, and medical emergencies. 100% online, nationally recognized, and licensing compliant."
        >
          Emergencies strike without warning. Caregivers are the first line of
          defense for the children they serve. AngelWatch delivers nationally
          recognized emergency response training — preparing your entire staff
          to respond FAST and save lives. — preparing child care professionals
          to respond immediately, protect lives, and comply with all state
          licensing requirements.
        </p>
        <div className="text-center m-auto" style={{ maxWidth: "1000px" }}>
          <h2>WHY CAREGIVER TRAINING MATTERS</h2>
          <p>
            Training isn`t optional — it`s protection. AngelWatch Certification
            equips caregivers with the real-world skills, the national
            credentials, and the confidence to act under pressure. Beyond
            protecting children, certification enhances career security and
            ensures full compliance with emergency licensing regulations.
          </p>
        </div>
        <h2 className="m-auto text-center mt-5 mb-0">
          What’s Included in the AngelWatch Caregiver Certification
        </h2>
        <div className="container py-5">
          <div className="row justify-content-center p-2  ">
            <div className={`${styles.careGiver} text-white `}>
              <h3 className="text-white">
                WHAT’S INCLUDED IN CAREGIVER CERTIFICATION
              </h3>
              <ul>
                <li className="p-2">
                  Active Shooter and Lockdown Response Training for Child Care
                  Settings
                </li>
                <li className="p-2">
                  Fire, Medical Emergency, and Natural Disaster Protocols
                </li>
                <li className="p-2">
                  Immediate Downloadable Certification Upon Completion
                </li>
                <li className="p-2">
                  State Licensing Compliance Training and Verification
                </li>
                <li className="p-2">
                  24/7 Online Access to Complete Courses at Your Own Pace
                </li>
                <li className="p-2">
                  Annual Recertification Reminders to Stay Current
                </li>
              </ul>
            </div>
            <div className={`${styles.careGiver} text-white `}>
              <h3 className="text-white">The Reality Most Educators Face:</h3>
              <ul>
                <li className="p-2">
                  Most educators are unaware of the exact protocols during
                  active shooter, lockdown, or parent-related emergencies.
                </li>
                <li className="p-2">
                  State-mandated emergency protocol training is rarely delivered
                  or often outdated.
                </li>
                <li className="p-2">
                  Many teachers don’t know what’s in their center’s emergency
                  plan—or whether it’s even compliant.
                </li>
                <li className="p-2">
                  Most available trainings are passive video modules with no
                  testing, tracking, or certification.
                </li>
              </ul>
            </div>
            <div>
              <div className={`${styles.careGiver} text-white`}>
                <h3 className="text-white">Why AngelWatch Is Different</h3>
                <ul>
                  <li className="p-2">
                    Designed exclusively for schools and daycares—not adapted
                    from corporate workplace safety.
                  </li>
                  <li className="p-2">
                    Built by an international defense contractor with experience
                    protecting U.S. government facilities worldwide.
                  </li>
                  <li className="p-2">
                    Partnered with the American Red Cross, the American Heart
                    Association, and backed by the Department of Homeland
                    Security.
                  </li>
                  <li className="p-2">
                    Patented, trademarked, and copyrighted to prevent dilution
                    or imitation.
                  </li>
                </ul>
              </div>
            </div>
            <div className={`${styles.careGiver} text-white`}>
              <h3 className="text-white">What You’ll Get:</h3>
              <ul>
                <li className="p-2">
                  12 months of unlimited access to the full AngelWatch Emergency
                  Management Certification System.
                </li>
                <li className="p-2">
                  Interactive, scenario-based training that immerses you in
                  real-world crisis simulations.
                </li>
                <li className="p-2">
                  Certification in active shooter response (internal &
                  external), combative parent scenarios, emergency lockdowns,
                  fire and weather protocols, and shelter-in-place procedures.
                </li>
                <li className="p-2">
                  Printable certificates for every module passed—ideal for
                  resumes and audit documentation.
                </li>
                <li className="p-2">
                  Recognition through the AngelWatch National Safety & Security
                  Accreditation Program.
                </li>
              </ul>
            </div>

            <div>
              <div className={`${styles.careGiver} text-white`}>
                <h3 className="text-white">Perfect For:</h3>
                <ul>
                  <li className="p-2">Public and private school teachers</li>
                  <li className="p-2">Preschool and daycare workers</li>
                  <li className="p-2">
                    Substitute teachers, coaches, and support staff
                  </li>
                  <li className="p-2">
                    Anyone working in early childhood education
                  </li>
                </ul>
              </div>
            </div>

            <div className={`${styles.careGiver} text-white`}>
              <h3 className="text-white">Why You Need This Certification:</h3>
              <ul>
                <li className="p-2">
                  Demonstrates that YOU are prepared, trained, and serious about
                  student safety.
                </li>
                <li className="p-2">
                  Helps your center meet its state licensing requirements.
                </li>
                <li className="p-2">
                  Gives parents confidence in you and your facility.
                </li>
                <li className="p-2">
                  Ensures that if a crisis happens—you react with instinct, not
                  panic.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p className={`${styles.warning} text-center m-auto mb-4`}>
          In a real crisis, hesitation costs lives. Many licensing agencies now
          require documented emergency preparedness training. AngelWatch
          Certification ensures you meet these standards and are fully ready to
          protect your children — and your career.
        </p>
        <h2 className="text-center m-4 p-4">
          Prepare to Protect Lives — Get Certified Today
        </h2>
        <div className="d-block d-lg-flex justify-content-between gap-2 m-auto w-75">
          <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
            <div
              className={`${styles.pricingCard} m-4`}
              style={{ minHeight: "700px" }}
            >
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Individual Teachers & Caregivers</span>
              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$159.00</p>
                <del className={styles.pricingOriginal}>Was $199</del>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>What’s included:</p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Unlimited access for your entire team</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Emergency Management System with tracking dashboard</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      Staff certification and automatic recertification alerts
                    </p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Compliance documents, SOPs, and protocol handbook</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <p>Free plan rewrite to pass licensing inspections</p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
          </div>
          <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
            <div className={styles.pricingCard} style={{ minHeight: "700px" }}>
              <img
                src={require("../../assets/img/discount2.jpg")}
                className={styles.pricingDiscount}
              ></img>
              <span>For Schools & Daycares</span>

              <div className={styles.pricingPrice}>
                <p className={styles.pricingNum}>$800.00</p>
                <del className={styles.pricingOriginal}>Was $1000</del>
                <p className={styles.pricingUnit}>/ Entire staff</p>
              </div>
              <div className={styles.pricingList}>
                <p className={styles.priceDes}>What’s included:</p>
                <div className={styles.pricingCardText}>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Full interactive course with scenario-based training</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Required testing and printable certification</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>Access for 12 months to refresh as needed</p>
                  </div>
                  <div className={styles.priceOptions}>
                    <img src={CheckImage} />
                    <p>
                      No hidden fees. No upcharges. No extra cost for
                      recertification or new hires.
                    </p>
                  </div>
                </div>
                <Link to="/selectregister" className={styles.priceButton}>
                  <button className={styles.pricingBtn}>Sign Up</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cta}>
          <h1 className={`text-white ${styles.cta__title}`}>
            Protect your children. Protect your staff. Stay compliant.
          </h1>
          <Link to="/getCertified">
            <button className={styles.cta__button}>
              Get Certified — Protect Your Students and Your Career -&gt;
            </button>
          </Link>
        </div>

        <section className={styles.contact__section}>
          <h1 className={styles.contact__heading}>Contact Us</h1>
          <div className={styles.contact}>
            <div>
              <h2 className={styles.contact__title}>
                For more information contact us
              </h2>
              <div>
                <img src={LogoImage} className={styles.contact__logoImg}></img>
              </div>
              <div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/email.png")}
                    className={styles.contact__img}
                  ></img>
                  <p className={styles.contact__item}>Edu@AngelWatch.org</p>
                </div>
                <div className={styles.contact__list}>
                  <img
                    src={require("../../assets/img/call.png")}
                    className={styles.contact__img}
                  ></img>
                  <p className={styles.contact__item}>+1 800-381-6794</p>
                </div>
              </div>
            </div>
            <div className={styles.contact__form}>
              <div>
                <p>Your name</p>
                <input
                  type="text"
                  className={styles.contact__input__info}
                  placeholder="John Smith"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                ></input>
              </div>
              <div>
                <p>Your email</p>
                <input
                  type="email"
                  name="email"
                  className={styles.contact__input__info}
                  placeholder="abc@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                ></input>
              </div>
              <div className={styles.contact__message__form}>
                <p>Your message</p>
                <textarea
                  type="text"
                  name="message"
                  className={styles.contact__message__input}
                  value={formData.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button
                style={{ marginBottom: "20px" }}
                onClick={handleSendMessage}
                disabled={!handleCaptchaChange}
              >
                Send Message
              </button>
              <ReCAPTCHA
                sitekey={process.env.REACT_APP_SITE_KEY}
                onChange={handleCaptchaChange}
                className={`${styles.captcha}`}
              />
            </div>
          </div>
        </section>

        {/* Master Skills */}
        {/* /Master Skills */}
        <section className="d-flex flex-column">
          <div className={styles.footerTop}>
            <div className={styles.footerSection}>
              <img className={styles.footerImage} src={logo} />
              <p className={styles.footerDes}>
                All of our techniques, trainings, equipment, software, hardware,
                and instructional materials are classified and proprietary to
                the AngelWatch Foundation. We do not publicly disclose our
                teaching methodologies. This confidentiality is essential to
                ensure the ongoing safety and security of our centers, staff,
                and the children entrusted to our care. By continuously
                improving, adapting, and evolving our systems, we remain one
                step ahead—proactively closing any potential gaps and ensuring
                every base is covered.
              </p>
            </div>

            <div className={styles.footerLoginSection}>
              <p className={styles.footerTitle}>School</p>
              <Link to="/login">
                <a className={styles.footerLink1}>Login</a>
              </Link>
              <Link to="/selectregister">
                <a className={styles.footerLink1}>Register</a>
              </Link>
            </div>

            <div className={styles.footerSection}>
              <p className={styles.footerTitle}>Newsletter</p>
              <input
                className={styles.newsLetter}
                placeholder="Enter your email address"
                type="text"
              />
              <p className={styles.footerLink1}>
                Hampton Reserve Drive, Brentwood tennessee, 37027
              </p>
              <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
              <p className={styles.footerLink1}>+1 800-381-6794</p>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <div className={styles.footerBottomLeft}>
              <p className={styles.footerLink}>Term</p>
              <p className={styles.footerLink}>|</p>
              <p className={styles.footerLink}>Privacy</p>
            </div>
            <div className={styles.footerBottomRight}>
              <p className={styles.footerLink}>
                © 2025 AngelWatch LMS. All rights reserved.
              </p>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};

export default CareGiver;
